const appInformation = {
    appTitle: 'Project Template UI',
    appLogo: '/images/logoTs.png',
    creator: 'Tomi Scattini',
    creatorWebsite: 'https://tomiscattini.com/',
    repositoryUrl: 'https://github.com/Tomasscattini/project-template.git'
};

export default appInformation;
